import TodoAdd from '@/components/todo-create';
import ListePatient from '@/components/dashboard/liste-patients' 

import CreanceVuePatients from '@/components/caisse/factures/creance-patients'
import BonsAttente from '@/components/dashboard/bons-attente'
import PrintBonMedical from '@/components/caisse/manage-bons/print-bon-medical'
import FactureEnCours from '@/components/dashboard/facture-en-cours'
import ReattributionConsultation from '@/components/dashboard/reattribution-consultation'
import AgendaRendezVous from '@/components/rendez-vous/agenda-rendez-vous'   // C8 : carte Rendez-vous
import ActiviteConsultations from '@/components/dashboard/activite-consultations'   // KPI-001 : cartes Consultations cliquables
import $ from 'jquery';
import { open_menu_state, openMenu, closeMenu } from '@/function/function.js';

export default {
    name: 'dashboard',
    components: {
        TodoAdd, ListePatient,
        CreanceVuePatients,
        BonsAttente, PrintBonMedical, FactureEnCours, ReattributionConsultation, AgendaRendezVous,
        ActiviteConsultations
    },
    props: [],
    data() {
        return {
            reattribution_ouverte: false,
            // Role utilisateur 
            user_role: 0,
            compte_id: 1,
            user_id: 0,

            idUser: 1,
            init_bon: null,
            active: false,
            init_anl: null,
            types_value: null,
            moments_error: null,
            types_error: null,
            total_recettes: 0,
            total_depenses: 0,
            total_versements_faits: 0,
            total_versements_recus: 0,

            // ------- CONSULTATION  ---------
            vm_state: open_menu_state,
            // ------------------------------
            solde_courant: 0,
            open_loading: false,
            loader: true,

            cash_register_is_closed: false,
            status_is_loading: true,

            is_creance_patient: false,
            filter_data: {},
            config_to_show: 'bon-attente',
            bon_is_printable: false,
            is_bon_consultation: false,
            info_bon: {},
            patients_visible: false,
            patients_observer: null
        }
    },

    watch: {
        'activeRole.nom'() {
            this.reattribution_ouverte = false
            this.config_to_show = 'bon-attente'
        }
    },

    computed: {
        peut_generer_bon() {
            return this.activeRole && (this.activeRole.nom === 'ROLE_ACCUEIL' || (this.activeRole.nom === 'ROLE_CAISSIERE' && this.statut_ouverture_caisse === 1))
        },
        peut_reattribuer() {
            return this.activeRole && ['ROLE_ACCUEIL', 'ROLE_CAISSIERE', 'ROLE_CAISSIERE_INTERMITENT'].indexOf(this.activeRole.nom) !== -1
        },
        // C8 : carte Rendez-vous pour les mêmes rôles que l'entrée Rendez-vous de la barre latérale
        voit_rendez_vous() {
            return !!this.activeRole && ['ROLE_CAISSIERE', 'ROLE_ACCUEIL', 'ROLE_CAISSIERE_INTERMITENT'].indexOf(this.activeRole.nom) !== -1
        },
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        userCompte() {
            return this.$store.getters["compteActiveUser"];
        },

        quick_actions() {
            return this.$store.getters["quickActionsDropdown"];
        },

        /**
         * Liste des patients en attente de consultation
         * @returns 
         */
        consultationsEnAttente() {
            return this.$store.getters['consultationsEnAttente'];
        },

        solde_disponible() {
            return this.$store.getters["solde_disponible"];
        },

        info_clinique_active() {
            return this.$store.getters["info_clinique_active"]
        },

        // ----------NEW ------------
        statut_ouverture_caisse() {
            return this.$store.getters['statutOuvertureCaisse'];
        },
    },
    mounted() {
        // La liste des patients est sous la ligne de flottaison : ne pas saturer
        // le serveur clinique pendant le chargement des statistiques et des bons.
        this.$nextTick(() => {
            const cible = this.$refs.patients_card
            if (!cible || typeof IntersectionObserver === 'undefined') {
                this.patients_visible = true
                return
            }
            this.patients_observer = new IntersectionObserver((entries) => {
                if (!entries.some(entry => entry.isIntersecting)) return
                this.patients_visible = true
                this.patients_observer.disconnect()
                this.patients_observer = null
            }, { rootMargin: '400px' })
            this.patients_observer.observe(cible)
        })
        this.$store.commit("SET_PAYING_BILL_STATE", '');
        this.$store.commit("SET_BILL_SELECTED_OPERATIONS", []);
        this.$store.commit("SET_PAYING_BILL_STATE", '');
        this.$store.commit("SET_IS_PAID", false);

        this.$store.commit("SET_IS_PRE_SAVED_BON", false);
        this.$store.commit("SET_SELECTED_BON_CONSOMMABLES", []);
        this.$store.commit("SET_SELECTED_BON_ID", null)

        this.$store.commit("SET_PAYMENT_ACTION", '');
        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_COMPTABLE' || this.activeRole.nom == 'ROLE_ADMINISTRATEUR') {
                this.$router.push({ path: '/tableau-de-bord' });
            } else if (this.activeRole.nom == 'ROLE_TRESORERIE') {
                this.$router.push({ path: '/tresorerie' });
            }
        }
        this.getCahRegisterStatus()

        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            this.v = 0;
            if (!$clicked.parents().hasClass("option-container")) {
                $(".option-box").removeClass("animate-fadeInRight");
                $(".option-box").addClass("animate-fadeOutRight");
                $(".option-box").fadeOut();
            }
        });
    },
    beforeDestroy() {
        if (this.patients_observer) this.patients_observer.disconnect()
    },

    methods: {
        generer_bon() { if (this.peut_generer_bon) this.dropQuickAction() },
        ouvrir_reattribution() {
            if (!this.peut_reattribuer) return
            this.reattribution_ouverte = true
        },
        // C8 : rendez-vous modifié depuis la carte Patients (fenêtre Rendez-vous du patient) → la carte Rendez-vous se recharge
        actualiser_rendez_vous() {
            if (this.$refs.agenda_rendez_vous) this.$refs.agenda_rendez_vous.charger()
        },
        /**
         * Open Menu Dropdown
         */
        openMenu(state, selector, show_in, show_out) {
            this.vm_state = openMenu.dropMenu(state, selector, show_in, show_out)
        },

        /**
         * Close Menu Dropdown
         */
        closeMenu(selector, show_in, show_out) {
            this.vm_state = closeMenu.wrapMenu(selector, show_in, show_out)
        },

        changeTab(tab_to_show) {
            this.config_to_show = tab_to_show
        },

        /**
         * Check if user can open cash register
         */
        getCahRegisterStatus() {
            this.status_is_loading = true
            this.$store.dispatch('getStatutOuvertureCaisse', this.compte_id).then(() => {
                this.status_is_loading = false
            })
        },


        getSoldeDisponible() {
            const data = {
                compte_id: this.compte_id,
                date: this.getDates().today_date,
                user_id: this.user_id
            }
            this.$store.dispatch("getSoldeDisponible", data).then(() => {
                this.solde_courant = parseInt(this.solde_disponible)
            })
        },

        ouvrirCaisse() {
            this.open_loading = true;

            // Récupère le solde disponible à une date donnée
            const data = {
                compte_id: this.compte_id,
                date: this.getDates().today_date,
                user_id: this.user_id
            }
            this.$store.dispatch("getSoldeDisponible", data).then(() => {
                this.solde_courant = parseInt(this.solde_courant)

                const opening_data = {
                    compte_id: this.compte_id,
                    user_id: this.user_id,
                    solde_ouverture: this.solde_disponible
                }
          
                this.$store.dispatch('openCaisse', opening_data).then((response) => {
                    if (response.success) {
                        this.getCahRegisterStatus()
                    } else {
                        if (response.code === 409) {
                            this.warningToast("La caisse a été déjà ouverte !")
                        } else if (response.code === 403) {
                            const curr_caisse = (this.compte_id == 1)?'infirmière':'principale'
                            this.warningToast("La caisse "+curr_caisse+" est ouverte !")
                        }
                    }
                    this.open_loading = false;
                }).catch(() => {
                    this.open_loading = false;
                })
            })
        },

        formatNumbers(num) {
            return new Number(num).toLocaleString("fr-FR");
        },
        getDates() {
            let today_date = new Date();
            let yesterday_date = new Date();
            yesterday_date.setDate(today_date.getDate() - 1);
            today_date = `${today_date.getFullYear()}-${today_date.getMonth() +
            1}-${today_date.getDate()}`;
            yesterday_date = `${yesterday_date.getFullYear()}-${yesterday_date.getMonth() +
            1}-${yesterday_date.getDate()}`;
            return { today_date, yesterday_date };
        },

        dropQuickAction: function() {
            this.$store.dispatch('setQuickActionsDropdown', !this.quick_actions)
        },

        leaveQuickAction: function() {
            this.$store.dispatch('setQuickActionsDropdown', false)
        },

        sum(array_given) {
            let total = 0;
            array_given.forEach(data => {
                total += parseInt(data.quantite * data.prix)
            });
            return total;
        },

        showDateFilter(date_filter) {
            this.is_creance_patient = true
            this.filter_date = date_filter
        },

        printBonMedical(data) {
            this.is_bon_consultation = data.is_bon_consultation
            this.info_bon = data.info_bon

            this.bon_is_printable = true
            setTimeout(() => {
                $('.p-bon-medical').modal('show')
                // this.bon_is_printable = false
            }, 200);
        }
    },

}
